import Immutable from 'seamless-immutable';

import {
    SUBMISSION_VERSIONS_DATA_REQUEST,
    SUBMISSION_VERSIONS_DATA_SUCCESS,
    SUBMISSION_VERSIONS_DATA_ERROR,
    SUBMISSION_ATTACHMENT_DATA_REQUEST,
    SUBMISSION_ATTACHMENT_DATA_SUCCESS,
    SUBMISSION_ATTACHMENT_DATA_ERROR,
    SUBMISSION_ADD_FILES_REQUEST,
    SUBMISSION_ADD_FILES_SUCCESS,
    SUBMISSION_ADD_FILES_ERROR,
} from 'Actions/submission';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    data: [],
    attachments: {},
    filterList: {
        include: ['file', 'user'],
        order: 'submission_attachments.id desc'
    },
    filter: {
        include: ['file', 'user'],
        order: 'submission_attachments.id desc'
    }
});

export default function packListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SUBMISSION_VERSIONS_DATA_REQUEST:
        case SUBMISSION_ATTACHMENT_DATA_REQUEST:
        case SUBMISSION_ADD_FILES_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case SUBMISSION_VERSIONS_DATA_SUCCESS: {
            return state.merge({
                loading: false,
                success: true,
                error: false,
                data: action.payload.data,
            });
        }

        case SUBMISSION_ATTACHMENT_DATA_SUCCESS:
            return state.merge({
                loading: false,
                success: true,
                error: false,
                attachments: state.attachments.merge(action.payload.data),
            });

        case SUBMISSION_ADD_FILES_SUCCESS:
            return state.merge({
                loading: false,
                success: true,
                error: false,
                attachments: state.attachments.merge({
                    [action.payload.data.type]: action.payload.data
                }),
            });

        case SUBMISSION_VERSIONS_DATA_ERROR:
        case SUBMISSION_ATTACHMENT_DATA_ERROR:
        case SUBMISSION_ADD_FILES_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/submissionAttachmentsReducer.js